import { useCallback, useEffect, useState } from 'react'
import { Link, Outlet, useLocation } from 'react-router-dom'
import Sidebar from './Sidebar'
import Topbar from './Topbar'

/**
 * Die Huelle aller Seiten: Sidebar links, Kopfzeile, Inhalt.
 *
 * Mobil (unter 860 px) faehrt die Sidebar von links herein -- ausgeloest
 * ueber das Menue-Zeichen oben links (Wunsch Kim). Sie schliesst beim
 * Seitenwechsel, per Escape und per Tipp auf den abgedunkelten Hintergrund.
 */
export default function AppShell() {
  const [navOffen, setNavOffen] = useState(false)
  const { pathname } = useLocation()
  const schliessen = useCallback(() => setNavOffen(false), [])

  useEffect(() => {
    setNavOffen(false)
    window.scrollTo(0, 0)
  }, [pathname])

  useEffect(() => {
    if (!navOffen) return
    const beiTaste = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setNavOffen(false)
    }
    document.addEventListener('keydown', beiTaste)
    const vorher = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', beiTaste)
      document.body.style.overflow = vorher
    }
  }, [navOffen])

  return (
    <div className={`q-app${navOffen ? ' nav-open' : ''}`}>
      <a href="#inhalt" className="q-skip">
        Zum Inhalt
      </a>
      <Sidebar offen={navOffen} onNavigate={schliessen} />
      <div className="q-backdrop" onClick={schliessen} aria-hidden="true" />

      <div className="q-main">
        <Topbar navOffen={navOffen} onMenu={() => setNavOffen((v) => !v)} />
        <main id="inhalt" className="q-content">
          <Outlet />
        </main>
        <footer className="q-legal">
          <Link to="/impressum">Impressum</Link>
          <Link to="/datenschutz">Datenschutz</Link>
          <Link to="/agb">AGB</Link>
          <span>Keine Anlageberatung.</span>
        </footer>
      </div>
    </div>
  )
}
